import { AnimalSpecies } from 'gql/types';
import { TFunction } from 'i18next';
import { ReportFilterOptions } from 'modules/reports/hooks/useReportFilterOptions';
import { ReportFilterConfig } from 'modules/reports/types';

import { ParsedIneligibleReport } from './types';

export const getIneligibleReportFilters = (
  t: TFunction,
  { locationNames }: ReportFilterOptions
): ReportFilterConfig<ParsedIneligibleReport>[] => [
  {
    key: 'createdAt',
    label: t('createdAt'),
    type: 'dateRange',
    getValue: (item) => item.createdAt,
  },
  {
    key: 'donorLocation',
    label: t('donorLocation'),
    type: 'multiselect',
    getValue: (item) => item.donorData?.location,
    options: locationNames,
  },
  {
    key: 'donorSpecies',
    label: t('donorSpecies'),
    type: 'multiselect',
    getValue: (item) => item.donorData?.species,
    options: Object.values(AnimalSpecies),
  },
];
